import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Toast } from 'antd-mobile';
import config from '@/config';
import { getTodayData } from '@/api/airportTransfer';
import './index.scss';

const Home = () => {
  const [userInfo, setUserInfo] = useState({});
  const [todayData, setTodayData] = useState({
    completeOrder: 0,
    inCome: 0,
    untreatedOrder: 0
  });
  const history = useHistory();

  useEffect(() => {
    document.title = '首页';
    // 设置页面标题（如果在 WebView 中）
    if (typeof window?.savePicture?.setTitle === 'function') {
      window?.savePicture?.setTitle('首页');
    }

    // 检查登录状态
    const token = localStorage.getItem('userToken');
    const driverDetail = localStorage.getItem('driverDetail');
    if (!token) {
      // 如果没有登录，跳转到登录页
      history.replace('/login');
      return;
    }

    // 获取今日数据
    fetchTodayData();
    if(driverDetail){
        setUserInfo(JSON.parse(driverDetail));
    }
  }, [history]);


  // 获取今日数据
  const fetchTodayData = async () => {
    try {
      const response = await getTodayData();
      if (response?.data?.code === 200) {
        setTodayData(response.data.data);
      }else if (response?.data?.errorCode === 110004){
        Toast.fail(response?.data?.errorMsg||'请先登录', 2)
        // 如果没有登录，跳转到登录页
        history.replace('/login');
        return;
      }else {
        console.error('获取今日数据失败', response?.data?.errorMsg);
      }
    } catch (error) {
      console.error('获取今日数据失败', error);
    }
  };

  // 跳转到抢单大厅
  const goToOrderHall = () => {
    history.push('/airportTransfer/list');
  };

  // 跳转到接单记录
  const goToOrderRecord = () => {
    history.push('/airportTransfer/list?tab=record');
  };

  // 跳转到司机钱包
  const goToWallet = () => {
    history.push('/wallet');
  };

  // 跳转到订单历史
  const goToOrderHistory = () => {
    Toast.info('跳转到订单历史', 1);
    // history.push('/order/history');
  };

  // 跳转到客服中心
  const goToService = () => {
    Toast.info('跳转到客服中心', 1);
    // history.push('/service');
  };

  // 跳转到设置
  const goToSettings = () => {
    history.push('/setting');
  };

  // 退出登录
  const handleLogout = () => {
    localStorage.removeItem('userToken');
    Toast.success('退出成功', 1);
    setTimeout(() => {
      history.replace('/login');
    }, 1000);
  };

  return (
    <div className="home-container">
      <div className="home-header">
        <div className="logo-wrapper">
          <img src={config.LOGO_IMG} alt="logo" className="logo" />
          <h1 className="app-title">{config.TITLE}</h1>
        </div>
        <div className="user-info">
          <p className="welcome-text">欢迎回来，司机{userInfo.driverName}师傅</p>
          <p className="status-text">今日可接单</p>
        </div>
      </div>

      <div className="home-content">
        <div className="quick-stats">
          <div className="stat-item">
            <div className="stat-number">{todayData.completeOrder}</div>
            <div className="stat-label">今日完单</div>
          </div>
          <div className="stat-item">
            <div className="stat-number">¥{todayData.inCome}</div>
            <div className="stat-label">今日收入</div>
          </div>
          <div className="stat-item clickable" onClick={goToOrderRecord}>
            <div className="stat-number">{todayData.untreatedOrder}</div>
            <div className="stat-label">待处理</div>
          </div>
        </div>

        <div className="main-menu">
          <div className="menu-title">
            <h2>主要功能</h2>
            <p>选择您要使用的功能</p>
          </div>

          <div className="menu-grid">
            <div className="menu-item" onClick={goToOrderHall}>
              <div className="menu-icon">
                <i className="iconfont icon-order"></i>
              </div>
              <div className="menu-content">
                <h3>抢单大厅</h3>
                <p>查看和抢取订单</p>
              </div>
              <div className="menu-arrow">
                <i className="iconfont icon-arrow-right"></i>
              </div>
            </div>

            <div className="menu-item" onClick={goToWallet}>
              <div className="menu-icon wallet">
                <i className="iconfont icon-wallet"></i>
              </div>
              <div className="menu-content">
                <h3>司机钱包</h3>
                <p>查看收入和提现</p>
              </div>
              <div className="menu-arrow">
                <i className="iconfont icon-arrow-right"></i>
              </div>
            </div>
          </div>
        </div>

        <div className="other-menu">
          <div className="menu-title">
            <h2>其他功能</h2>
          </div>

          <div className="menu-list">
            {/* <div className="list-item" onClick={goToOrderHistory}>
              <div className="list-icon">
                <i className="iconfont icon-history"></i>
              </div>
              <span className="list-label">订单历史</span>
              <i className="iconfont icon-arrow-right"></i>
            </div>

            <div className="list-item" onClick={goToService}>
              <div className="list-icon">
                <i className="iconfont icon-service"></i>
              </div>
              <span className="list-label">客服中心</span>
              <i className="iconfont icon-arrow-right"></i>
            </div>

            <div className="list-item" onClick={goToSettings}>
              <div className="list-icon">
                <i className="iconfont icon-setting"></i>
              </div>
              <span className="list-label">设置</span>
              <i className="iconfont icon-arrow-right"></i>
            </div> */}

            <div className="list-item" onClick={handleLogout}>
              <div className="list-icon logout">
                <i className="iconfont icon-logout"></i>
              </div>
              <span className="list-label logout">退出登录</span>
              <i className="iconfont icon-arrow-right"></i>
            </div>
          </div>
        </div>
      </div>

      <div className="home-footer">
        <p>如有问题，请联系客服：{config.TEL}</p>
      </div>
    </div>
  );
};

export default Home;